import React, { Component } from "react";
import { PriceAdvisor } from "../../organisms";

export class PricePage extends Component {
  render() {
    return <PriceAdvisor />;
  }
}
